<template>
    <div class="Multiparty">
        <el-form label-width="130px" label-position="left" :model="params" :rules="rulesparams" ref="params">
            <div class="item">
                <b class="title">会议发起背景</b>
                <el-form-item label="会议发起日期" prop="meetStartTime">
                    <el-date-picker 
                    v-model="params.meetStartTime" 
                    placeholder="选择会商日期" 
                    type="datetime" 
                    format="yyyy-MM-dd HH:mm"
                    value-format="yyyy-MM-dd HH:mm"
                    :disabled="num==1?true:false"
                    ></el-date-picker>
                </el-form-item>

                <el-row>
                    <el-col :span="12">
                        <el-form-item label="会议发起者院所">
                            <el-input type="text" v-model="params.promoterDept" disabled ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="心理辅导员">
                            <el-input type="text" v-model="params.psychologyCounselor" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <b class="title">危机学生基本信息</b>

                <el-row>
                    <el-col :span="12">
                        <el-form-item label="姓名">
                            <el-input v-model="params.realName" type="text" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="学号">
                            <el-input v-model="params.userID" type="text" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="12">
                        <el-form-item label="危机学生情况简要描述">
                            <el-input v-model="params.stateDescribe" type="text" :disabled="num==1?true:false" maxlength="50" show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="会议发起原因及诉求">
                            <el-input v-model="params.reasonAppeal" type="text" :disabled="num==1?true:false" maxlength="50" show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-form-item label="与会部门/人员">
                    <el-checkbox-group v-model="params.conferenceRelate" :disabled="num==1?true:false">
                        <el-checkbox label="1">心理辅导员</el-checkbox>
                        <el-checkbox label="2">心理中心</el-checkbox>
                        <el-checkbox label="3">院所领导</el-checkbox>
                        <el-checkbox label="4">学生本人</el-checkbox>
                        <el-checkbox label="5">学生监护人</el-checkbox>
                        <el-checkbox label="6">其他</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
            </div>

            <div class="item">
                <b class="title">多部门会议纪要</b>

                <el-row>
                    <el-col :span="12">
                        <el-form-item label="会商日期" prop="consultTime">
                            <el-date-picker 
                            v-model="params.consultTime" 
                            type="datetime" 
                            placeholder="选择会商日期" 
                            format="yyyy-MM-dd HH:mm"
                            value-format="yyyy-MM-dd HH:mm"  :disabled="num==1?true:false"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="会议记录者">
                            <el-input v-model="params.recordID" type="text" :disabled="num==1?true:false" maxlength="50" show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="12">
                        <el-form-item label="与会部门">
                            <el-input v-model="params.withDept" type="text" :disabled="num==1?true:false" maxlength="50" show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="与会人员">
                            <el-input v-model="params.withPersonnel" type="text" :disabled="num==1?true:false" maxlength="50" show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <b class="title">会议记录</b>
                <el-form-item label="会议纪要">
                    <el-input v-model="params.meetMinutes" type="textarea" :disabled="num==1?true:false" maxlength="500" show-word-limit></el-input>
                </el-form-item>

                <el-form-item label="待跟进内容">
                    <el-input v-model="params.followContent" type="textarea" :disabled="num==1?true:false" maxlength="500" show-word-limit></el-input>
                </el-form-item>

                <el-form-item v-if="num==0">
                    <el-button type="primary" @click="submit()" >提交记录</el-button>
                </el-form-item>
            </div>

        </el-form>
    </div>
</template>
<script>
    export default{
        data() {
            return {
                num:this.$route.query.num,
                rulesparams:{
                    meetStartTime: [ { required: true, message: '请选择会议发起日期', trigger: 'change' }],
                    consultTime: [ { required: true, message: '请选择会商日期', trigger: 'change' }],
                },
                params:{
                    keyNo:'',
                    meetStartTime:'',//会议发起日期
                    promoterDept:'',//会议发起者院所
                    psychologyCounselor:'',//心理辅导员
                    realName:'',//姓名
                    userID:'',//学号
                    stateDescribe:'',//危机学生情况简要描述
                    reasonAppeal:'',//会议发起原因及诉求
                    conferenceRelate:[],//与会部门/人员
                    consultTime:'',//会商日期
                    recordID:'',//会议记录者
                    withDept:'',//与会部门
                    withPersonnel:'',//与人员
                    meetMinutes:'',//会议纪要
                    followContent:''//待跟进内容
                },
                isclick:true
            }
        },
        mounted() {
            this.params.keyNo=this.$route.query.KeyNo;
            if(this.num==0){
                this.multipartyTalkBringInfo()
            }else{
                this.multipartyTalkInfo()
            }
            
        },
        methods: {
            multipartyTalkBringInfo(){
                this.$Http_Post('management/distressPrediction/multipartyTalkBringInfo',{keyNo:this.params.keyNo}).then(res=>{
                    if(res.Code==0){
                        this.params['keyNo']=this.$route.query.KeyNo;
                        this.params.promoterDept=res.Data.deptName;
                        this.params.psychologyCounselor=res.Data.counsellorName;
                        this.params.userID=res.Data.userID;
                        this.params.realName=res.Data.stuName;
                    }else{
                        this.$message({message:res.Message,type: 'error'});
                    }
                })
            },
            // 回显
            multipartyTalkInfo(){
                this.$Http_Post('management/distressPrediction/multipartyTalkInfo',{mtalk:this.params.keyNo}).then(res=>{
                    if(res.Code==0){
                        this.params=res.Data;
                        this.params['conferenceRelate']=res.Data.conferenceRelates;
                    }else{
                        this.$message({message:res.Message,type: 'error'});
                    }
                });
            },
            submit(){
                this.$refs['params'].validate((valid) => {
                if (valid) {
                        if(this.isclick){
                            this.isclick=false;
                            this.$Http_Post('management/distressPrediction/multipartyTalk',this.params).then(res=>{
                                this.isclick=true;
                                if(res.Code==0){
                                    this.$message({message:res.Message,type: 'success'});
                                    this.$router.go(-1);
                                }else{
                                    this.$message({message:res.Message,type: 'error'});
                                }
                            });
                        }else{
                            this.$message({message:"请勿重复提交",type: 'warning'});
                        }
                    }else{
                        this.$message({message:"请填写完整信息",type: 'warning'});
                    }
                })
            }
        },
    }
</script>
<style>
.Multiparty .item{background: #fff;padding: 20px;margin-bottom: 20px;border-radius: 8px;}
.Multiparty .item .title{font-size: 16px;padding-bottom: 20px;display: block;}
.Multiparty .el-input{width:360px;}
.Multiparty .el-textarea,.Multiparty .el-textarea textarea{height: 115px;}
</style>